import { Injectable } from "@angular/core";

import { OpenIdConfiguration } from "angular-auth-oidc-client";

import { AppSettings } from "./appsettings";
import { AuthConfig } from "./auth.config";

@Injectable({
  providedIn: "root",
})
export class AuthConfigService {
  constructor() {}

  getConfig(): OpenIdConfiguration {
    return {
      authority: AppSettings.API_ENDPOINT,
      redirectUrl: AuthConfig.redirectUrl,
      postLogoutRedirectUri: window.location.origin,
      clientId: "hxaportal",
      scope: "openid profile offline_access IdentityServerApi",
      responseType: "code",
      silentRenew: true,
      renewTimeBeforeTokenExpiresInSeconds: 5,
      useRefreshToken: true,
      logLevel: AuthConfig.logLevel,
      postLoginRoute: "/home",
      historyCleanupOff: false,
    };
  }
}
